<script setup>
import Layout from "../../Components/Shared/LayoutAdmin.vue";
import CategoryForm from "../../Components/Forms/CategoryForm.vue";
import TableItem from "../../Components/Shared/TableItem.vue";
import ModalComponent from "../../Components/Shared/ModalComponent.vue";
import ButtonComponent from "../../Components/Shared/ButtonComponent.vue";
import { Link } from "@inertiajs/inertia-vue3";
import HeaderAdminComponent from "../../Components/Shared/HeaderAdminComponent.vue";

import { ref } from "vue";
import useApi from "../../Services/useApi";
import { Inertia } from "@inertiajs/inertia";
import useNotification from "../../Services/useNotification";

const props = defineProps(["categories"]);
const modalTitle = ref("Crear");
const api = useApi();
const notificate = useNotification()
//category
const categoryModal = ref(false);
const initCategory = {
    name: "",
};
const categoryToCreate = ref(initCategory);
const createCategory = () => {
    categoryToCreate.value = initCategory;
    categoryModal.value = true;
    modalTitle.value = "Crear";
};
const editCategory = (category) => {
    categoryToCreate.value = category;
    categoryModal.value = true;
    modalTitle.value = "Editar";
};
const deleteCategory = (category) => {
    notificate.confirm("Seguro que quieres eliminar esta categoria ?",()=>{
        api.deleteCategory(category).then((response) => {
            console.log(response);
            notificate.success("Eliminado!");
            Inertia.reload();
        });
    })
};
const resetModals = () => {
    categoryModal.value = false;
};
</script>

<template lang="">
    <Layout>
        <HeaderAdminComponent title="Categorias"></HeaderAdminComponent>
        <div class="container w-full mx-auto my-14 px-10">
            <ButtonComponent 
                content="Atrás" 
                :icon="'arrow_back_ios'"
                :link="'/admin'"
                type="2"
            />
            <h1 class="my-5 text-lg font-bold text-enriqueto_green">Categorias</h1>
            <ButtonComponent 
                content="Añadir nueva categoria" 
                :icon="null"
                :link="null"
                type="0"
                @click="createCategory" 
            />
            <div class="w-full my-10">
                <div class="flex w-full" v-for="item in categories" :key="item.id">
                    <Link class="w-full" :href="'/category/'+item.id+'/fruits'">
                        <TableItem :items="[
                            { key: 'id', name: 'ID',value:item.id , width: '10%' },
                            { key: 'name', name: 'Nombre',value:item.name , width: '90%' },
                        ]" /> 
                    </Link>
                    <div class="w-20 ml-6" v-if="$page.props.isAdmin==true">
                        <div class="flex pt-10">
                            <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/borrar_enriqueto.svg" @click="deleteCategory(item)" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' categoria'"
            v-model="categoryModal"
            v-if="categoryModal"
        >
            <CategoryForm @added="resetModals" :category="categoryToCreate" />
        </ModalComponent>
    </Layout>
</template>

<style lang="">
    
</style>